import { render } from "./EmailCustomTemplateToolbar.vue?vue&type=template&id=2ccd7206"
import script from "./EmailCustomTemplateToolbar.vue?vue&type=script&lang=js"
export * from "./EmailCustomTemplateToolbar.vue?vue&type=script&lang=js"

import "./EmailCustomTemplateToolbar.vue?vue&type=style&index=0&id=2ccd7206&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__